import React, { useEffect, useState } from "react";
import "./ProfessionalForm.css";

import {
    FaArrowRight,
    FaBriefcase,
    FaCheckCircle,
    FaClock,
    FaLocationDot,
    FaPhone,
    FaShieldAlt,
    FaStar,
    FaUsers,
} from "react-icons/fa";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Bgimg1 from "./Bgimg1.webp";
import Bgimg2 from "./Bgimg2.webp";
import Bgimg3 from "./Bgimg3.webp";
import Bgimg4 from "./Bgimg4.webp";
import Bgimg5 from "./Bgimg5.webp";


const ProfessionalForm = () => {

    /* =========================================================
       HERO SLIDER
    ========================================================= */

    const slides = [
        {
            src: Bgimg1,
            duration: 4000,
        },
        {
            src: Bgimg2,
            duration: 4000,
        },
        {
            src: Bgimg3,
            duration: 4000,
        },
        {
            src: Bgimg4,
            duration: 4000,
        },
        {
            src: Bgimg5,
            duration: 4000,
        },
    ];

    const [currentSlide, setCurrentSlide] = useState(0);


    useEffect(() => {

        slides.forEach((slide) => {
            const img = new Image();
            img.src = slide.src;
        });

    }, []);


    useEffect(() => {

        const timer = setTimeout(() => {

            setCurrentSlide(
                (prev) => (prev + 1) % slides.length
            );

        }, slides[currentSlide].duration);

        return () => clearTimeout(timer);

    }, [currentSlide]);


    /* =========================================================
       DEMO FORM
    ========================================================= */

    const [step, setStep] = useState(1);

    const [mode, setMode] = useState("Online");

    const [verifying, setVerifying] = useState(false);

    const [sendingOtp, setSendingOtp] = useState(false);

    const [showDemoForm, setShowDemoForm] = useState(false);


    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        otp: "",
        slotDay: "",
        slotTime: "",
        graduationYear: "",
        nativePlace: "",
    });


    /* =========================================================
       CITIES
    ========================================================= */

    const cities = [
        "Hyderabad",
        "Warangal",
        "Hanamkonda",
        "Karimnagar",
        "Nizamabad",
        "Khammam",
        "Ramagundam",
        "Mahbubnagar",
        "Adilabad",
        "Suryapet",
        "Miryalaguda",
        "Jagtial",
        "Mancherial",
        "Nalgonda",
        "Siddipet",
        "Sangareddy",
        "Medak",
        "Vikarabad",
        "Kamareddy",
        "Bhadradri Kothagudem",
        "Nagarkurnool",
        "Wanaparthy",
        "Mulugu",
        "Narayanpet",
        "Jogulamba Gadwal",
        "Medchal",
        "Yadadri Bhuvanagiri",

        "Visakhapatnam",
        "Vijayawada",
        "Guntur",
        "Nellore",
        "Kurnool",
        "Rajahmundry",
        "Kakinada",
        "Tirupati",
        "Kadapa",
        "Anantapur",
        "Eluru",
        "Ongole",
        "Srikakulam",
        "Vizianagaram",
        "Chittoor",
        "Machilipatnam",
        "Tenali",
        "Hindupur",
        "Proddatur",
        "Bhimavaram",
        "Tadepalligudem",
        "Narasaraopet",
        "Gudivada",
        "Adoni",
        "Amalapuram",
        "Nandyal",
        "Dharmavaram",
        "Rayachoti",
        "Madanapalle",
        "Puttur",
        "Tuni",
        "Samalkot",
        "Palakollu",
        "Repalle",
        "Chilakaluripet",
        "Markapur",
        "Kavali",
        "Kadiri",
        "Rajampet",
        "Bapatla",
    ];


    /* =========================================================
       INPUT CHANGE
    ========================================================= */

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };


    /* =========================================================
       OPEN DEMO FORM
    ========================================================= */

    const openDemoForm = () => {

        setShowDemoForm(true);

        document.body.style.overflow = "hidden";

    };


    /* =========================================================
       CLOSE DEMO FORM
    ========================================================= */

    const closeDemoForm = () => {

        setShowDemoForm(false);

        document.body.style.overflow = "auto";

    };


    /* =========================================================
       SEND OTP
    ========================================================= */

    const handleNext = async () => {

        if (!formData.name || !formData.phone) {

            toast.error("Please enter name & phone");

            return;
        }


        setSendingOtp(true);

        const toastId = toast.loading("Sending OTP...");


        try {

            const res = await fetch(
                `https://api.prtacademy.com/api/verify/send?phone=${formData.phone}`,
                {
                    method: "POST",
                }
            );


            if (res.ok) {

                toast.update(toastId, {
                    render: "OTP sent successfully",
                    type: "success",
                    isLoading: false,
                    autoClose: 2000,
                });

                setStep(2);

            } else {

                toast.update(toastId, {
                    render: "Failed to send OTP ❌",
                    type: "error",
                    isLoading: false,
                    autoClose: 2000,
                });

            }

        } catch (error) {

            console.error(error);

            toast.update(toastId, {
                render: "Server error. Try again later ❌",
                type: "error",
                isLoading: false,
                autoClose: 2000,
            });

        } finally {

            setSendingOtp(false);

        }

    };


    /* =========================================================
       VERIFY OTP
    ========================================================= */

    const verifyOtp = async () => {

        setVerifying(true);


        try {

            const res = await fetch(
                `https://api.prtacademy.com/api/verify/check?phone=${formData.phone}&otp=${formData.otp}`,
                {
                    method: "POST",
                }
            );


            const data = await res.text();


            if (data.includes("Verified")) {

                toast.success("OTP Verified");

                setStep(3);

            } else {

                toast.error("Invalid OTP");

            }

        } catch (error) {

            console.error(error);

            toast.error("Verification failed");

        } finally {

            setVerifying(false);

        }

    };


    /* =========================================================
       SUBMIT DEMO
    ========================================================= */

    const handleSubmit = async () => {

        try {

            const finalData = {
                ...formData,
                classType: mode,
            };


            const res = await fetch(
                "https://api.prtacademy.com/api/demo/book",
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(finalData),
                }
            );


            if (res.ok) {

                toast.success(
                    "Demo Booked Successfully"
                );

                setStep(1);

                setFormData({
                    name: "",
                    phone: "",
                    otp: "",
                    slotDay: "",
                    slotTime: "",
                    graduationYear: "",
                    nativePlace: "",
                });

                closeDemoForm();

            } else {

                toast.error(
                    "Something went wrong"
                );

            }

        } catch (error) {

            console.error(error);

            toast.error(
                "Server error"
            );

        }

    };


    return (

        <>

            {/* =====================================================
                HERO
            ===================================================== */}

            <section className="hero-container">


                {/* =================================================
                    LEFT CONTENT
                ================================================= */}

                <div className="hero-content">


                    {/* ANNOUNCEMENT */}
                    <div className="hero-announcement">

                        <span className="announcement-dot"></span>

                        <span>
                            New Batches Starting Next Monday in KPHB
                        </span>

                        <strong>
                            LIMITED 15 SEATS/BATCH
                        </strong>

                    </div>


                    {/* HEADING */}

                    <h1 className="hero-title">

                        Transform Your Career

                        <br />

                        with 6 Months{" "}

                        <span className="gradient-text">
                            Training
                        </span>

                        <br />

                        &{" "}

                        <span className="gradient-text">
                            Placement Support
                        </span>

                    </h1>


                    {/* DESCRIPTION */}

                    <p className="hero-description">

                        Master Java Full Stack or MERN Stack in KPHB,
                        Hyderabad. Get personalized mentorship in small
                        15-student batches backed by dedicated placement
                        assistance.

                    </p>


                    {/* FEATURE CARDS */}

                    <div className="hero-features">


                        <div className="hero-feature-card">

                            <div className="feature-icon">
                                <FaBriefcase />
                            </div>

                            <div>

                                <strong>
                                    Live Projects
                                </strong>

                                <span>
                                    2 Months Included
                                </span>

                            </div>

                        </div>


                        <div className="hero-feature-card">

                            <div className="feature-icon">
                                <FaShieldAlt />
                            </div>

                            <div>

                                <strong>
                                    50% Refund Terms
                                </strong>

                                <span>
                                    Risk-Free Protection
                                </span>

                            </div>

                        </div>


                        <div className="hero-feature-card">

                            <div className="feature-icon">
                                <FaUsers />
                            </div>

                            <div>

                                <strong>
                                    15 Students
                                </strong>

                                <span>
                                    Max Batch Size
                                </span>

                            </div>

                        </div>


                    </div>


                    {/* CTA BUTTONS */}

                    <div className="hero-actions">

                        <button
                            className="primary-hero-btn"
                            onClick={openDemoForm}
                        >

                            <span>
                                ✨
                            </span>

                            Book Free Demo Slot

                            <FaArrowRight />

                        </button>


                        <button
                            className="secondary-hero-btn"
                            onClick={() =>
                                document
                                    .getElementById("courses")
                                    ?.scrollIntoView({
                                        behavior: "smooth",
                                    })
                            }
                        >

                            View Course Tracks

                        </button>

                    </div>


                    {/* DIVIDER */}

                    <div className="hero-divider"></div>


                    {/* BENEFITS */}

                    <div className="hero-benefits">

                        <div>

                            <FaCheckCircle />

                            <span>
                                Zero Prior Coding Needed
                            </span>

                        </div>


                        <div>

                            <FaCheckCircle />

                            <span>
                                Daily Jam Sessions
                            </span>

                        </div>


                        <div>

                            <FaCheckCircle />

                            <span>
                                In-Classroom & Online
                            </span>

                        </div>

                    </div>


                </div>


                {/* =================================================
                    RIGHT IMAGE
                ================================================= */}

                <div className="hero-visual">


                    <div className="hero-image-card">


                        {/* IMAGE SLIDES */}

                        {slides.map((slide, index) => (

                            <img
                                key={index}
                                src={slide.src}
                                alt={`PRT Academy training ${index + 1}`}
                                className={
                                    `hero-image-slide ${
                                        currentSlide === index
                                            ? "active"
                                            : ""
                                    }`
                                }
                            />

                        ))}


                        {/* IMAGE OVERLAY */}

                        <div className="hero-image-overlay"></div>


                        {/* INDUSTRY BADGE */}

                        <div className="industry-certified">

                            <div className="certified-icon">
                                <FaShieldAlt />
                            </div>

                            <div>

                                <span>
                                    Industry Certified
                                </span>

                                <small>
                                    DRC Skill Validation
                                </small>

                            </div>

                        </div>


                        {/* BOTTOM IMAGE INFO */}

                        <div className="hero-image-info">


                            <div className="student-rating">


                                <div className="student-avatars">

                                    <span>SK</span>
                                    <span>PR</span>
                                    <span>AN</span>

                                </div>


                                <div className="rating-content">

                                    <div className="stars">

                                        <FaStar />
                                        <FaStar />
                                        <FaStar />
                                        <FaStar />
                                        <FaStar />

                                        <strong>
                                            4.9/5
                                        </strong>

                                    </div>

                                    <small>
                                        500+ Placed Students in Hyderabad
                                    </small>

                                </div>

                            </div>


                            <button
                                className="image-demo-btn"
                                onClick={openDemoForm}
                            >
                                Free Demo
                            </button>


                        </div>


                    </div>


                </div>


            </section>


            {/* =====================================================
                DEMO FORM MODAL
            ===================================================== */}

            {showDemoForm && (

                <div
                    className="demo-modal"
                    onClick={closeDemoForm}
                >

                    <div
                        className="demo-modal-card"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <button
                            className="demo-close"
                            onClick={closeDemoForm}
                            aria-label="Close"
                        >
                            ×
                        </button>


                        <div className="demo-modal-header">

                            <span>
                                PRT ACADEMY
                            </span>

                            <h2>
                                Book a Free Demo
                            </h2>

                            <p>
                                Complete the quick form and our
                                team will help you choose the right
                                course.
                            </p>

                        </div>


                        {/* STEPS */}

                        <div className="steps">

                            <div className="step-wrapper">

                                <div
                                    className={
                                        `step ${
                                            step >= 1
                                                ? "active"
                                                : ""
                                        }`
                                    }
                                >
                                    1
                                </div>

                                <div
                                    className={
                                        `line ${
                                            step >= 2
                                                ? "active"
                                                : ""
                                        }`
                                    }
                                ></div>

                            </div>


                            <div className="step-wrapper">

                                <div
                                    className={
                                        `step ${
                                            step >= 2
                                                ? "active"
                                                : ""
                                        }`
                                    }
                                >
                                    2
                                </div>

                                <div
                                    className={
                                        `line ${
                                            step >= 3
                                                ? "active"
                                                : ""
                                        }`
                                    }
                                ></div>

                            </div>


                            <div className="step-wrapper">

                                <div
                                    className={
                                        `step ${
                                            step >= 3
                                                ? "active"
                                                : ""
                                        }`
                                    }
                                >
                                    3
                                </div>

                            </div>

                        </div>


                        {/* STEP 1 */}

                        {step === 1 && (

                            <>

                                <input
                                    name="name"
                                    placeholder="Full Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                />


                                <input
                                    name="phone"
                                    placeholder="Phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />


                                <button
                                    onClick={handleNext}
                                    className="cta-btn"
                                    disabled={sendingOtp}
                                >

                                    {sendingOtp
                                        ? "Sending OTP..."
                                        : "Continue"}

                                </button>

                            </>

                        )}


                        {/* STEP 2 */}

                        {step === 2 && (

                            <>

                                <input
                                    name="otp"
                                    placeholder="Enter OTP"
                                    value={formData.otp}
                                    onChange={handleChange}
                                />


                                <button
                                    className="cta-btn"
                                    onClick={verifyOtp}
                                    disabled={verifying}
                                >

                                    {verifying
                                        ? "Verifying..."
                                        : "Verify OTP"}

                                </button>

                            </>

                        )}


                        {/* STEP 3 */}

                        {step === 3 && (

                            <>

                                <div className="toggle-container">

                                    <button
                                        type="button"
                                        className={
                                            mode === "Online"
                                                ? "toggle active"
                                                : "toggle"
                                        }
                                        onClick={() =>
                                            setMode("Online")
                                        }
                                    >
                                        Online
                                    </button>


                                    <button
                                        type="button"
                                        className={
                                            mode === "Offline"
                                                ? "toggle active"
                                                : "toggle"
                                        }
                                        onClick={() =>
                                            setMode("Offline")
                                        }
                                    >
                                        Offline
                                    </button>

                                </div>


                                {mode === "Online" && (

                                    <>

                                        <div className="slot-group">

                                            <button
                                                type="button"
                                                className={
                                                    formData.slotDay ===
                                                    "Today"
                                                        ? "slot active"
                                                        : "slot"
                                                }
                                                onClick={() =>
                                                    setFormData({
                                                        ...formData,
                                                        slotDay: "Today",
                                                    })
                                                }
                                            >
                                                Today
                                            </button>


                                            <button
                                                type="button"
                                                className={
                                                    formData.slotDay ===
                                                    "Tomorrow"
                                                        ? "slot active"
                                                        : "slot"
                                                }
                                                onClick={() =>
                                                    setFormData({
                                                        ...formData,
                                                        slotDay: "Tomorrow",
                                                    })
                                                }
                                            >
                                                Tomorrow
                                            </button>

                                        </div>


                                        <div className="slot-group">

                                            <button
                                                type="button"
                                                className={
                                                    formData.slotTime ===
                                                    "11AM"
                                                        ? "slot active"
                                                        : "slot"
                                                }
                                                onClick={() =>
                                                    setFormData({
                                                        ...formData,
                                                        slotTime: "11AM",
                                                    })
                                                }
                                            >
                                                11:00 AM
                                            </button>


                                            <button
                                                type="button"
                                                className={
                                                    formData.slotTime ===
                                                    "6PM"
                                                        ? "slot active"
                                                        : "slot"
                                                }
                                                onClick={() =>
                                                    setFormData({
                                                        ...formData,
                                                        slotTime: "6PM",
                                                    })
                                                }
                                            >
                                                6:00 PM
                                            </button>

                                        </div>


                                        <select
                                            name="graduationYear"
                                            value={
                                                formData.graduationYear
                                            }
                                            onChange={handleChange}
                                        >

                                            <option value="">
                                                Select Graduation Year
                                            </option>

                                            {[2026, 2025, 2024, 2023, 2022].map(
                                                (year) => (
                                                    <option
                                                        key={year}
                                                        value={year}
                                                    >
                                                        {year}
                                                    </option>
                                                )
                                            )}

                                        </select>


                                        <label>
                                            Native Place
                                        </label>

                                        <select
                                            name="nativePlace"
                                            value={
                                                formData.nativePlace
                                            }
                                            onChange={handleChange}
                                        >

                                            <option value="">
                                                Select City
                                            </option>

                                            {cities.map(
                                                (city, index) => (
                                                    <option
                                                        key={index}
                                                        value={city}
                                                    >
                                                        {city}
                                                    </option>
                                                )
                                            )}

                                        </select>

                                    </>

                                )}


                                {mode === "Offline" && (

                                    <>

                                        <label>
                                            Year of Graduation
                                        </label>

                                        <select
                                            name="graduationYear"
                                            value={
                                                formData.graduationYear
                                            }
                                            onChange={handleChange}
                                        >

                                            <option value="">
                                                Select Year
                                            </option>

                                            {Array.from(
                                                { length: 10 },
                                                (_, i) => {

                                                    const year =
                                                        new Date().getFullYear() -
                                                        i;

                                                    return (
                                                        <option
                                                            key={year}
                                                            value={year}
                                                        >
                                                            {year}
                                                        </option>
                                                    );

                                                }
                                            )}

                                        </select>


                                        <label>
                                            Native Place
                                        </label>

                                        <select
                                            name="nativePlace"
                                            value={
                                                formData.nativePlace
                                            }
                                            onChange={handleChange}
                                        >

                                            <option value="">
                                                Select City
                                            </option>

                                            {cities.map(
                                                (city, index) => (
                                                    <option
                                                        key={index}
                                                        value={city}
                                                    >
                                                        {city}
                                                    </option>
                                                )
                                            )}

                                        </select>

                                    </>

                                )}


                                <button
                                    className="cta-btn"
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>

                            </>

                        )}

                    </div>

                </div>

            )}


            <ToastContainer
                position="top-right"
                autoClose={3000}
            />

        </>

    );

};


export default ProfessionalForm;